/**
 * RestoID — MFA factor picker (verification).
 * ---------------------------------------------------------------------------
 * RestoID frame around `custom/components/MfaFactorRows` — NOT upstream's
 * `MfaFactorList`, which renders a different row (Logto's own icon set and a
 * one-line label). The invalid-session guard mirrors the upstream page exactly.
 * Swapped in via `src/App.tsx`.
 */
import { useTranslation } from 'react-i18next';

import FirstScreenLayout from '@/Layout/FirstScreenLayout';
import useMfaFlowState from '@/hooks/use-mfa-factors-state';
import { UserMfaFlow } from '@/types';

import MfaFactorRows from '../components/MfaFactorRows';
import { ScreenHead, Stack } from '../components/restoid';

import ErrorPage from './ErrorPage';

const MfaVerification = () => {
  const { t } = useTranslation();
  const flowState = useMfaFlowState();

  if (!flowState) {
    return <ErrorPage title="error.invalid_session" />;
  }

  return (
    <FirstScreenLayout pageMeta={{ titleKey: 'mfa.verify_mfa_factors' }}>
      <Stack gap={20}>
        <ScreenHead title={t('mfa.verify_mfa_factors')} sub={t('mfa.verify_mfa_description')} />
        <MfaFactorRows flow={UserMfaFlow.MfaVerification} flowState={flowState} />
      </Stack>
    </FirstScreenLayout>
  );
};

export default MfaVerification;
